module.exports = __webpack_public_path__ + "static/media/iqra3.89a92b76.jpg";